"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var omit_1 = tslib_1.__importDefault(require("lodash/omit"));
var Box_1 = require("../Box");
var hocs_1 = require("../hocs");
var StyledTab_1 = require("./StyledTab");
var TabInner = /** @class */ (function (_super) {
    tslib_1.__extends(TabInner, _super);
    function TabInner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            over: false
        };
        _this.onMouseOver = function (event) {
            var onMouseOver = _this.props.onMouseOver;
            _this.setState({ over: true });
            if (onMouseOver) {
                onMouseOver(event);
            }
        };
        _this.onMouseOut = function (event) {
            var onMouseOut = _this.props.onMouseOut;
            _this.setState({ over: undefined });
            if (onMouseOut) {
                onMouseOut(event);
            }
        };
        _this.onClickTab = function (event) {
            var _a = _this.props, onSelectTab = _a.onSelectTab, onActivate = _a.onActivate;
            event.preventDefault();
            event.stopPropagation();
            if (onActivate) {
                onActivate();
            }
            if (onSelectTab) {
                onSelectTab();
            }
        };
        return _this;
    }
    TabInner.getDerivedStateFromProps = function (nextProps, prevState) {
        var active = nextProps.active;
        var over = prevState.over;
        if (active && over) {
            return { over: undefined };
        }
        return null;
    };
    TabInner.prototype.render = function () {
        var _a = this.props, active = _a.active, forwardRef = _a.forwardRef, icon = _a.icon, plain = _a.plain, title = _a.title, theme = _a.theme, rest = tslib_1.__rest(_a, ["active", "forwardRef", "icon", "plain", "title", "theme"]);
        var normalizedTitle = title;
        var tabStyles = {};
        if (!theme) {
            return null;
        }
        return (React.createElement(StyledTab_1.StyledTabContainer, tslib_1.__assign({ className: "styledTabContainer", ref: forwardRef, role: "tab", "aria-selected": active, "aria-expanded": active, active: active }, omit_1.default(rest, ['onActivate', 'onSelectTab']), { onClick: this.onClickTab, onMouseOver: this.onMouseOver, onMouseOut: this.onMouseOut, onFocus: this.onMouseOver, onBlur: this.onMouseOut }),
            React.createElement(StyledTab_1.StyledTab, tslib_1.__assign({ as: Box_1.Box, plain: plain }, tabStyles, { className: "styledTab" }),
                normalizedTitle,
                icon && icon)));
    };
    return TabInner;
}(React.Component));
/** @component */
exports.Tab = recompose_1.compose(styled_components_1.withTheme, hocs_1.withForwardRef)(TabInner);
//# sourceMappingURL=Tab.js.map